import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { PageActions, PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { LocationManagementLocationKind } from "types/locationManagement/locationKind";
import { RevivnDatabaseDataGrid } from "components/DataGrid/RevivnDatabaseDataGrid";
import { linkColDef } from "components/DataGrid/columnDefs/linkColDef";

const LocationKindList: React.FC = () => {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Admin" }, { label: "Location Kinds", path: "/location-kinds" }]} />
      <PageTitle>Location Kinds</PageTitle>
      <PageSubtitle>
        What a location physically is, such as a rack, tote, or gaylord. A kind is optional and does not change whether
        the location can move.
      </PageSubtitle>
      <PageActions>
        <Button variant="contained" color="primary" component={Link} to="/location-kinds/new">
          Create Location Kind
        </Button>
      </PageActions>
      <RevivnDatabaseDataGrid
        url="/location_management/location_kinds"
        syncStateWithSearchParams
        columns={[
          { field: "id", headerName: "ID", width: 90 },
          {
            field: "name",
            headerName: "Location Kind",
            width: 200,
            filterable: false,
            ...linkColDef<LocationManagementLocationKind>(({ row }) => `/location-kinds/${row.id}/edit`),
          },
        ]}
        pageSize={25}
      />
    </FullPagePaperLayout>
  );
};

export default LocationKindList;
